module.exports = __webpack_public_path__ + "assets/1edcb730312d26ab41db33b7a19fc1da.mp3";